export const fileToBase64String = (selectedFile: File) => {
  const reader = new FileReader();
  reader.onload = function (e) {
    const dataURL = e.target!.result;
    sessionStorage.setItem('selectedFile', JSON.stringify(dataURL));
  };
  reader.readAsDataURL(selectedFile);
};
